const raceCategoryList = [
  "American Indian or Alaska Native",
  "Argentinean",
  "Asian",
  "Asian Indian",
  "Black or African American",
  "Cambodian",
  "Cherokee",
  "Chinese",
  "Chippewa",
  "Choctaw",
  "Colombian",
  "Cuban",
  "Declined to State",
  "Dominican",
  "Filipino",
  "Guamanian",
  "Hawaiian",
  "Hispanic or Latino",
  "Hmong",
  "Japanese",
  "Korean",
  "Laotian",
  "Mexican American",
  "Middle Eastern",
  "Navajo",
  "Nicaraguan",
  "Other Asian",
  "Other Pacific Islander",
  "Pueblo",
  "Puerto Rican",
  "Salvadoran",
  "Samoan",
  "Sioux",
  "Spaniard",
  "Tahitian",
  "Vietnamese",
  "White",
];

export default raceCategoryList;
